// Reiner Resolver: entscheidet anhand des Hostnames, welche Supabase-Werte genutzt werden.
// Nur der Lovable-Preview-Host wird zwingend auf das Staging-Projekt umgeleitet,
// alle anderen Hosts nutzen unverändert die übergebenen Env-Werte.

const PREVIEW_HOST = 'id-preview--7b5ffcba-1b6d-451d-b90b-010dbe7bd159.lovable.app';
const STAGING_URL = 'https://ccgrpdaghhrmulphfmjs.supabase.co';
const STAGING_PUBLISHABLE_KEY = 'sb_publishable_gfTHcMGCrisDkRF4Muq5pg_5H1BvDIh';

// Locked until explicit operator permission after live safety checks.
// All public AimUp hosts must switch together to avoid split databases.
// This is a PUBLIC browser key, never a private Supabase or Stripe secret.
const OWN_PRODUCTION_CUTOVER_ENABLED = true;
const OWN_PRODUCTION_URL = "https://umtkxgaszpdweduykzmx.supabase.co";
const OWN_PRODUCTION_PUBLISHABLE_KEY = "sb_publishable_QSjoU1HrqaE_1U7cwMhavA_M2Kn2CZC";
const PUBLIC_PRODUCTION_HOSTS = new Set([
  "aimupdarts.com",
  "www.aimupdarts.com",
  "aimup-darts.lovable.app",
]);

export function resolveSupabaseRuntimeConfig(
  hostname: string,
  envUrl: string,
  envPublishableKey: string,
): { url: string; publishableKey: string } {
  if (hostname === PREVIEW_HOST) {
    return { url: STAGING_URL, publishableKey: STAGING_PUBLISHABLE_KEY };
  }
  if (OWN_PRODUCTION_CUTOVER_ENABLED && PUBLIC_PRODUCTION_HOSTS.has(hostname)) {
    return {
      url: OWN_PRODUCTION_URL,
      publishableKey: OWN_PRODUCTION_PUBLISHABLE_KEY,
    };
  }
  return { url: envUrl, publishableKey: envPublishableKey };
}
